import { type FC, type ReactNode } from 'react'
import classNames from 'classnames'
import './AlertIcon.scss'

const ICON_FONT_SIZE_REM = 1

export interface AlertIconProps {
  size: number
  active: boolean
  children: ReactNode
}

export const AlertIcon: FC<AlertIconProps> = ({ size, active, children }) => {
  const padding = (size - ICON_FONT_SIZE_REM) / 2

  return (
    <div
      className={classNames('d-flex align-items-center', { 'alert-icon-container': active })}
      style={active ? { width: `${size}rem`, height: `${size}rem`, padding: `${padding}rem`, margin: `${-padding}rem` } : undefined}
    >
      {children}
    </div>
  )
}
